/**
 * Author: Claude Code
 * Version: v3.2.102
 * Modified: 2025-10-13
 *
 * LoadingTestPage - P0.4 Pure React Loading Screen Test (Clean Version)
 * 纯净版本：只显示加载界面，无控制面板
 */

import { useState } from 'react';
import LoadingScreen from '../components/LoadingScreen';

export default function LoadingTestPage() {
  const [showLoading, setShowLoading] = useState(true);
  const [loadingKey, setLoadingKey] = useState(0);

  const handleLoadingComplete = () => {
    console.log('✅ Loading completed!');
    // 1秒后自动重启，实现循环测试
    setTimeout(() => {
      setLoadingKey(prev => prev + 1);
      setShowLoading(true);
    }, 1000);
  };

  return <LoadingScreen key={loadingKey} onComplete={handleLoadingComplete} />;
}
